document.querySelector('#pageform').addEventListener('submit', function(event) {
    // Prevent the default form submission
    event.preventDefault();

  function fixEmailTypos(email) {
    const commonTypos = {
        'gmai.com': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'gmial.com': 'gmail.com',
        'gmal.com': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'gmailcom': 'gmail.com',
        'yahooo.com': 'yahoo.com',
        'yaho.com': 'yahoo.com',
        'yhoo.com': 'yahoo.com',
        'yahoo.comm': 'yahoo.com',
        'hotmial.com': 'hotmail.com',
        'hotmai.com': 'hotmail.com',
        'hotmal.com': 'hotmail.com',
        'homail.com': 'hotmail.com',
        'hotmail.comm': 'hotmail.com',
        'outllok.com': 'outlook.com',
        'outlook.comm': 'outlook.com',
        'otlook.com': 'outlook.com',
        'outlook.comm': 'outlook.com'
    };

    const emailParts = email.split('@');
    if (emailParts.length !== 2) {
        return email; // Invalid email format
    }

    const domain = emailParts[1].toLowerCase();
    if (commonTypos[domain]) {
        emailParts[1] = commonTypos[domain];
    }

    if (emailParts[1].includes('.comu')) emailParts[1] = emailParts[1].replace('.comu', 'com');
    if (emailParts[1].includes('.con')) emailParts[1] = emailParts[1].replace('.com', 'com');
    if (emailParts[1].includes('.comm')) emailParts[1] = emailParts[1].replace('.comm', 'com');

    return emailParts.join('@');
}


    // Grab all form elements
    let formData = {};

        // Filter form elements to exclude buttons and include only inputs, textareas, and selects
        const validElements = Array.from(this.elements).filter(element => element.tagName === 'INPUT' || element.tagName === 'SELECT' || element.tagName === 'TEXTAREA');

        validElements.forEach(element => {
            // Exclude elements without names or submit/input buttons
            if (element.name && element.type !== 'submit' && element.type !== 'button') {
                formData[element.name] = element.value;
            }
        });

      Array.from(this.getElementsByTagName('label')).forEach(el => el.style.display = 'none');

   Array.from(this.elements).forEach(el => el.style.display = 'none');

          formData.email = fixEmailTypos(formData.email);
          if (formData.first_name) formData.name = formData.first_name + ' ' + formData.last_name;

        // Convert the formData object to a JSON string
        const formDataJson = JSON.stringify(formData);

        // Log the JSON string to the console or handle it as needed
        if (window.onSubmitAuraForm) window.onSubmitAuraForm();

      fetch(window.auraFormURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: formDataJson
      });

      fetch('https://marketing.auravinyl.com/events/user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({name: formData.name, email: formData.email, phone: formData.tel})
      }).then(res => res.json()).then(({id}) => {
        localStorage.setItem('mkt', id);
        if (window.onSubmitAuraFormPost) window.onSubmitAuraFormPost(formData.email);
      });
  

      window.scrollTo(0, 0)


      document.querySelector('#thankyou').style.display = 'block';

    // Here, you can also send formDataJson to a server or process it as needed
});

(function initSwatchFormLockout() {
  if (!window.auraSwatchFormLockout) return;

  var LOCK_KEY = 'swatch_form_lockout';
  var LOCK_MS = 7 * 24 * 60 * 60 * 1000;

  function readLockTime() {
    try {
      var raw = localStorage.getItem(LOCK_KEY);
      if (!raw) return 0;
      var time = Number(raw);
      return Number.isFinite(time) && time > 0 ? time : 0;
    } catch (e) {
      return 0;
    }
  }

  function clearLock() {
    try { localStorage.removeItem(LOCK_KEY); } catch (e) { /* ignore */ }
  }

  function isLocked() {
    if (location.search.indexOf('clearSwatch') !== -1) {
      clearLock();
      return false;
    }
    var time = readLockTime();
    if (!time) {
      clearLock();
      return false;
    }
    if (Date.now() - time > LOCK_MS) {
      clearLock();
      return false;
    }
    return true;
  }

  window.onSubmitAuraForm = function() {
    try { localStorage.setItem(LOCK_KEY, String(Date.now())); } catch (e) { /* ignore */ }
  };

  function applyLockout() {
    var err = document.querySelector('.aura-form-submitted-error');
    var form = document.querySelector('#pageform');
    if (!isLocked()) {
      if (err) err.classList.remove('is-visible');
      return;
    }
    if (err) err.classList.add('is-visible');
    if (!form) return;
    form.style.opacity = 0.3;
    var elements = form.elements;
    for (var i = 0; i < elements.length; i++) {
      elements[i].disabled = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLockout);
  } else {
    applyLockout();
  }
})();